import React from 'react';
import { ArrowDownIcon, ArrowRightIcon } from 'lucide-react';
import { MockupCrop } from '../MockupCrop';
import { Accent, SectionHeading } from './SectionHeading';
import { howItWorks } from '../../data/content';
import { devicesArea } from '../../data/images';

/** Section 4 — class-ready in three steps. */
export function HowItWorksSection() {
  return <section aria-labelledby="how-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-116" data-mp="3hnh4cxl0taf6">
      <div className="mx-auto max-w-6xl" data-id="element-117" data-mp="3lp2n2zk8kixa">
        <SectionHeading id="how-heading" title={<>
              From “What Am I Teaching Today?” to <Accent data-id="element-119" data-mp="3vi9pcbjojit5">Class-Ready in 3 Simple Steps.</Accent>
            </>} data-id="element-118" data-mp="3qpgldpw1cei4" />

        <ol className="mt-14 grid items-stretch gap-3 lg:grid-cols-[1fr_auto_1fr_auto_1fr] lg:gap-4" data-id="element-120" data-mp="49cd85sklkeu">
          {howItWorks.map((step, index) => <React.Fragment key={step.name} data-id="element-121" data-mp="dbbv10bessiu" data-mpi={index}>
              <li className="flex h-full flex-col rounded-[22px] border border-brand-charcoal/8 bg-white px-7 py-8 shadow-[0_30px_60px_-44px_rgba(59,27,87,0.5)]" data-id="element-122" data-mp="dc55ab9ku05q">
                <p className="font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-gold" data-id="element-123" data-mp="2u82ou2r1mnkg">{step.step}</p>
                <p className="mt-2 font-display text-[2.6rem] font-bold italic leading-none text-brand-plum" data-id="element-124" data-mp="2p9rgjwgecl4c">{step.name}</p>
                <p className="mt-5 text-[17px] font-semibold leading-snug text-brand-charcoal" data-id="element-125" data-mp="2kb6gbx15a1fw">{step.title}</p>
                <p className="mt-2 text-[15px] leading-relaxed text-brand-charcoal/65" data-id="element-126" data-mp="3hwm26woy9qje">{step.description}</p>
              </li>
              {index < howItWorks.length - 1 && <li aria-hidden="true" className="flex items-center justify-center text-brand-gold" data-id="element-127" data-mp="3869e4uhxff8i">
                  <ArrowDownIcon className="h-6 w-6 lg:hidden" strokeWidth={1.5} data-id="element-128" data-mp="337y7stqubmv1" />
                  <ArrowRightIcon className="hidden h-6 w-6 lg:block" strokeWidth={1.5} data-id="element-129" data-mp="4jiuoxrkzvce" />
                </li>}
            </React.Fragment>)}
        </ol>

        <MockupCrop crop={devicesArea} alt="Real Makeup Instructor Ready pages on a tablet, laptop and phone" className="mx-auto mt-14 max-w-4xl" data-id="element-130" data-mp="1tz3242oqbr0c" />

        <p className="mt-10 text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-131" data-mp="1ka2z8873wbgv">
          No starting from <Accent data-id="element-132" data-mp="1p7bk4gjn2tlt">a blank page.</Accent>
        </p>
      </div>
    </section>;
}